import { $, _, Backbone, Foundation, Radio, moment, Datepicker } from "../../../vendor";
import InboomaBaseView from "../InboomaBaseView";
import Notification from "../../utils/Notification";

import UserDiscountSidebarTpl from "../../templates/pricediscounts/UserDiscountSidebarTpl.html";

export default InboomaBaseView.extend({
  /* TODO: All that this._updateNotification(); should be called by collection,
     as an "collection:changed" event
     */

  template: UserDiscountSidebarTpl,
  el: "#inb-c-sidebar",
  templateContext() {
    return {
      _,
      moment,
    };
  },

  _filterCountNotification: {},
  _collectionEmptyNotification: {},

  ui: {},

  events: {},

  initialize() {
    this.render();
  },
});
